import axios, { AxiosInstance, AxiosRequestConfig } from 'axios'
import { IDropOffTypeData, IPaginatedData } from './types'
import DropOffType from '../../domain/models/DropOffType'
import { IDropOffTypeProvider } from '../../domain/providers/DropOffTypeProvider'

class DropOffTypeProvider implements IDropOffTypeProvider {
  public http: AxiosInstance
  public apiUrl: string

  constructor(baseURL: string) {
    const apiUrl = `${baseURL}/api/v1`
    const config: AxiosRequestConfig = {
      baseURL: apiUrl,
      headers: {
        'content-type': 'application/json'
      }
    }
    this.http = axios.create(config)
    this.apiUrl = apiUrl
  }

  public static toDropOffType(data: IDropOffTypeData): DropOffType {
    return new DropOffType(data.name, data.id)
  }

  async fetchAvailableDropOffTypes(): Promise<Array<DropOffType>> {
    const { data } = await this.http.get<IPaginatedData<IDropOffTypeData>>('/dropofftypes')

    return data.content.map((it) => DropOffTypeProvider.toDropOffType(it))
  }

  generateIconUrl(icon: string, color: string): string {
    const colorCode = color.replace('#', '%23')
    return `${this.apiUrl}/dropofftypes/icons/${icon}.svg?color=${colorCode}`
  }
}

export default DropOffTypeProvider
